<!-- 运行环境左侧列表项 -->
<template>
  <div class='h100vh-116'>
    <div class='h-scroll h100-40'>
      <div id='randomId'>
        <ejs-listview id='flat-list' ref="runEnvironmentLeft" :dataSource='runEnvironmentList' :fields='runEnvironmentField' :select='selectEnvironment'></ejs-listview>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "runEnvironment-left",
    data(){
      return{
        runEnvironmentList: [
          {'id': 'list-1', 'name': 'POC-DP服务'},
          {'id': 'list-2', 'name': 'Kubernetes'},
          {'id': 'list-3', 'name': '基站设备'},
          {'id': 'list-4', 'name': '服务器'},
          {'id': 'list-5', 'name': 'OpenStack'},
          {'id': 'list-6', 'name': 'Aliyun'}
        ],
        runEnvironmentField: {id: 'id', text: 'name', tooltip: 'name'},
      }
    },

    methods: {
      // 点击运行环境事件
      selectEnvironment(args){
        this.$emit('getSelectItem', args.data.id, args.data.name);
      },
    },
  }
</script>

